import { Breakpoints } from '@/hooks/useBreakpoint';
import styled from 'styled-components';

export const Container = styled.div<{ $breakpoint: Breakpoints }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${({ theme, $breakpoint }) =>
    $breakpoint === 'mobile'
      ? `${theme.spacing[7]}px ${theme.spacing[5]}px`
      : `${theme.spacing[6]}px`};
  background-color: ${({ theme }) => theme.colors.neutral.neutral[2]};
  border-radius: ${({ theme }) => theme.radius[5]}px;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ChildrenContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  /* For Webkit browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.3);
    }
  }

  /* Hide scroll buttons in Chrome */
  &::-webkit-scrollbar-button {
    display: none;
  }

  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

  /* Hide scrollbar when not in use (macOS style) */
  &::-webkit-scrollbar-thumb {
    visibility: hidden;
  }

  &:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
`;
